<template>
    <div class="">
        <template v-if="sendRequest.action">
            <div v-text="sendRequest.action.type" :class="sendRequest.action.actioned?'text-green-600':''"></div>
            <div class="text-green-600 text-xs" v-if="sendRequest.action.actioned"
                 v-text="'Actioned @ '+moment(sendRequest.action.actioned).format('YYYY-MM-DD HH:mm')"></div>
        </template>
        <template v-else>
            <div class="text-gray-300 italic">No action required</div>
        </template>
    </div>
</template>

<script>

import moment from "moment";
import UiDropdown from "../ui/UiDropdown.vue";
import UiDropdownItem from "../ui/UiDropdownItem.vue";

export default {
    computed: {
        moment() {
            return moment
        }
    },
    components: {UiDropdownItem, UiDropdown},
    props: {
        sendRequest: Object,
    },
    data() {
        return {}
    },
    methods: {
        getClass(sendRequest) {
            if (sendRequest.status === 'Revoked' || sendRequest.status === 'Invalidated') {
                return ' line-through'
            }
            return '';
        }
    },
}
</script>
